import React,{useEffect} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormattedMessage } from 'react-intl';
import useConfig from './hooks/useConfig';
export default function PremiumUser() {
    const [open, setOpen] = React.useState(true);
    const { showLoader, hideLoader } = useConfig();
    // Premium accounts aren't available in the new Insight, so on OK redirect to the
    // classic UI (never log out) — the user's active session is picked up there.
    // Build the URL the same way "Switch to classic" does (strip /mui, trim slashes).
    const handleClose = () => {
        setOpen(false);
        showLoader();
        const redirectUrl = process.env.camSdkRedirectUrl || window.location.origin + '/';
        const baseUrl = String(redirectUrl).replace(/\/mui\/?/i, '').replace(/\/+$/, '');
        window.location.href = `${baseUrl}/classic`;
    };
    useEffect(()=>{
        hideLoader();
    },[])

    return (
        <React.Fragment>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <FormattedMessage id="warning" />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <FormattedMessage id="premiumUserWarning" />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} autoFocus>
                        <FormattedMessage id="okCommon" />
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}